import { TaxCodeDto } from "../../../../../models/tax-code.dto";

/** Only tax codes that are both enabled and set as default can be linked to a pay period */
export const isLinkableTaxCode = (taxCode: Pick<TaxCodeDto, "enabled" | "isDefault">) =>
	taxCode.enabled && taxCode.isDefault === true;

export const NOT_LINKABLE_TAX_CODE_MESSAGE =
	"Only tax codes that are enabled and set as default can be linked to a pay period";
